import * as React from 'react';
import { SVGProps } from 'react';

const IconCardsCompactSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.5 3h4v2.5h-4V3ZM1.5 6.5h4V9h-4V6.5ZM6.5 3h4v2.5h-4V3ZM6.5 6.5h4V9h-4V6.5Z" />
  </svg>
);
export default IconCardsCompactSizeXs;
